import React from 'react';
import { Helmet } from "react-helmet";
import '../../styles/transport.css'; // Import Transport specific CSS
import '../../styles/Fonts.css'; // Import Font specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

import bgImage from '../../assets/new/track.webp';
import TransportServices from './TransportServices';
import TransportBenefits from './TransportBenefits';
import TransportFAQ from './TransportFAQ';

const HeroTransport = () => {
  return (
    <>
      <Helmet>
        <title>Transport Services | RCS Logistics Philippines</title>
        <meta name="description" content="Professional transport services by RCS Logistics Philippines. Reliable delivery solutions with expert handling, real-time tracking, and comprehensive coverage across the Philippines." />
        <meta name="keywords" content="transport services, logistics transport, delivery services, freight transport, cargo transport, RCS Logistics Philippines, professional transport, reliable delivery, freight forwarding" />
        <meta property="og:url" content="https://rcslogisticsph.com/transport" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Transport Services | RCS Logistics Philippines" />
        <meta property="og:description" content="Professional transport services with reliable delivery solutions and expert handling by RCS Logistics Philippines." />
        <meta property="og:image" content="https://rcslogisticsph.com/transport-hero-image.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Transport Services | RCS Logistics Philippines" />
        <meta property="twitter:description" content="Professional transport services with reliable delivery solutions and expert handling by RCS Logistics Philippines." />
        <meta property="twitter:image" content="https://rcslogisticsph.com/transport-hero-image.png" />
      </Helmet>

      {/* Hero Section */}
      <section 
        className="transport-hero-section" 
        style={{ 
          backgroundImage: `url(${bgImage})`
        }}
      >
        <div className="transport-hero-overlay"></div>
        <div className="container hero-content">
          <div className="row">
            <div className="col-lg-10 col-xl-9">
              <div className="text-start">
                <button className="hero-badge" disabled>
                  PROFESSIONAL TRANSPORT SERVICES
                </button>
                <h1 className="hero-main-title text-white">
                  Reliable Transport Solutions
                </h1>
                <p className="hero-description text-white">
                  Professional transportation services with reliable delivery solutions and comprehensive coverage nationwide.
                </p>
                <div className="hero-actions">
                  <a href="/contactUs" className="btn-primary-hero">Get a Quote</a>
                  <a href="#transport-services" className="btn-secondary-hero">Our Services</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Include the other sections */}
      <TransportServices />
      <TransportBenefits />
      <TransportFAQ />
    </>
  );
};

export default HeroTransport;
